import {useSelector} from "react-redux";
import {useCookies} from "react-cookie";
import jwt_decode from "jwt-decode";
import {Button, TextField} from "@mui/material";
import {useState} from "react";
import {updatePassword} from "./actions/auth";
import roles from "./utilities/roles";

const Profile = () => {
    const auth = useSelector(state => state.auth.value );
    //const [cookies, setCookie, removeCookie] = useCookies(['access_token']);
    const [cookies] = useCookies(['access_token']);
    const [ newPassword, setNewPassword ] = useState('');
    const [ newPasswordConfirmation, setNewPasswordConfirmation ] = useState('');
    const [ updatingPassword, setUpdatingPassword ] = useState(false);
    const [ showPasswordUpdated, setShowPasswordUpdated ] = useState(false);
    const [ showFailedToUpdatePassword, setShowFailedToUpdatePassword ] = useState(false);
    const decoded = jwt_decode(cookies.access_token);

    const processPwUpdate = async () => {
        setUpdatingPassword(true);
        const result = await updatePassword(auth.token, newPassword);
        if( result.status === "success" ) {
            setShowPasswordUpdated(true);
            setShowFailedToUpdatePassword(false);
        } else {
            setShowPasswordUpdated(false);
            setShowFailedToUpdatePassword(true);
        }
        setUpdatingPassword(false);
    };

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <h1>Profile</h1>
            <TextField style={{marginLeft: 10, marginTop: 10, width: 200}} id="username" label="Username" variant="outlined" value={decoded.user.username} disabled={true}/>
            <TextField style={{marginLeft: 10, marginTop: 10, width: 200}} id="username" label="Role" variant="outlined" value={roles[decoded.user.role]} disabled={true}/>
            <div style={{ margin: 10, padding: 5, borderRadius: 4, width: 200, display: newPassword !== newPasswordConfirmation ? undefined : "none", backgroundColor: "#FFDDDD", color: "red" , textAlign: "center"}}>Passwords do not match</div>
            <TextField type="password" onChange={(e) => setNewPassword(e.target.value)} style={{marginLeft: 10, marginTop: 10, width: 200}} id="new-password" label="New Password" variant="outlined" value={newPassword} />
            <TextField type="password" onChange={(e) => setNewPasswordConfirmation(e.target.value)} style={{marginLeft: 10, marginTop: 10, width: 200}} id="new-password-confirmation" label="Confirm New Password" variant="outlined" value={newPasswordConfirmation} />
            <Button style={{margin: 10, width: 200}} variant="contained" color="primary" disabled={newPassword.length === 0 || newPassword !== newPasswordConfirmation} onClick={processPwUpdate}>Update Password</Button>
            <div style={{ margin: 10, padding: 5, borderRadius: 4, width: 200, display: showFailedToUpdatePassword ? undefined : "none", backgroundColor: "#FFDDDD", color: "red" , textAlign: "center"}}>Failed to update password</div>
            <div style={{ margin: 10, padding: 5, borderRadius: 4, width: 200, display: showPasswordUpdated ? undefined : "none", backgroundColor: "#006225", color: "white", textAlign: "center" }}>Password updated.</div>
            {updatingPassword ? (
                <div style={{position: "fixed", top:0, bottom: 0, left: 0, right:0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div className="lds-roller">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default Profile;